module.exports = new __parcel__URL__("Key_Technologies_2.b21b3460.jpg").toString();